import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/exam-states/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const examStates = {
  getAll: apiPathFunc(pathBase),
} as const;
